export default {
  title: 'Points',
  help_title: 'Help',
  active: 'Active',
  inactive: 'Inactive',
  coming_soon: 'Coming soon',
  migrating: 'Migrating',
  archived: 'Archived',
}
